import { Injectable } from '@angular/core';
import { PractitionerAPIResponse, Practitioner } from '../interfaces/practitioner';
import { IdentifierAPIResponse } from '../interfaces/identifier';
import { AddressAdapter } from './address.adapter';
import { QualificationAdapter } from './qualification.adapter';
import { TelecomAdapter } from './telecom.adapter';

@Injectable({
  providedIn: 'root',
})
export class PractitionerByOrganizationAdapter {
  constructor(private addressAdapter: AddressAdapter, private qualificationAdapter: QualificationAdapter, private telecomAdapter: TelecomAdapter) {}

  public adapterToModel(practitionerFHIR: PractitionerAPIResponse): Practitioner {
    const identifier = this.extractIdentifiers(practitionerFHIR.identifier);
    const telecom = this.telecomAdapter.adapterToModel(practitionerFHIR?.telecom!);
    const qualifications = this.qualificationAdapter.adapterToModel(practitionerFHIR?.qualification);

    return {
      practitioner_id: practitionerFHIR.practitioner_id,
      name: practitionerFHIR.name,
      gender:practitionerFHIR.gender,
      birthDate: practitionerFHIR.birthDate,
      cpf: identifier.CPF ?? '',
      phone: telecom?.phone ?? undefined,
      mobile: telecom?.mobile ?? undefined,
      active: practitionerFHIR.active,
      qualifications: qualifications.qualifications,
      certificates: qualifications.certifications,
      communication: practitionerFHIR.communication,
      accessibilities: practitionerFHIR.accessibilities,
      photo: practitionerFHIR.photo,
      modifiedDays: practitionerFHIR.modifiedDays ?? [],
      created_by_organization : practitionerFHIR.created_by_organization,
      created_at : practitionerFHIR.created_at,
      updated_at : practitionerFHIR.created_at
    };
  }

  public adaptToAPIFormat(practitionerModel: Practitioner): PractitionerAPIResponse {
    return {
      practitioner_id: practitionerModel.practitioner_id ?? '"1233455"',
      name: practitionerModel.name,
      identifier: [{ value: practitionerModel.cpf, system: 'CPF' }],
      gender: practitionerModel.gender,
      birthDate: practitionerModel.birthDate,
      telecom: this.telecomAdapter.adaptToAPIFormat(practitionerModel.email, practitionerModel.phone, practitionerModel.mobile),
      qualification: practitionerModel.qualifications
        ? this.qualificationAdapter.adaptToAPIFormat(practitionerModel.qualifications, practitionerModel.certificates)
        : [],
      address: practitionerModel.address ? this.addressAdapter.adaptToAPIFormat(practitionerModel.address) : [],
      communication: practitionerModel.communication ?? [],
      active: practitionerModel.active,
      accessibilities: practitionerModel.accessibilities,
      photo: practitionerModel.photo,
      modifiedDays: practitionerModel?.modifiedDays ?? [],
      created_by_organization : practitionerModel.created_by_organization,
      created_at : practitionerModel.created_at,
      updated_at : practitionerModel.created_at
    };
  }

  private extractIdentifiers(identifiers: IdentifierAPIResponse[]) {
    let CPF: string | null = null;
    let CRM: string | null = null;
    let CNPJ: string | null = null;

    identifiers.forEach((identifier) => {
      const { system, value } = identifier;

      if (system === 'CPF') {
        CPF = value;
      } else if (system === 'CRM') {
        CRM = value;
      } else if (system === 'CNPJ') {
        CNPJ = value;
      }
    });

    return { CPF, CRM, CNPJ };
  }
}
